import { render, staticRenderFns } from "./MonthlyResults.vue?vue&type=template&id=97fd9666&"
import script from "./MonthlyResults.vue?vue&type=script&lang=ts&"
export * from "./MonthlyResults.vue?vue&type=script&lang=ts&"
import style0 from "./MonthlyResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports